<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('已布置作业') }}</h4>
            <div class="flex flex-v-center">
                <el-input style="border-radius: 20px;" :placeholder="$t('请输入作业名称')" v-model="name">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
        </div>

        <el-table :header-cell-style="{ background: '#f5f7fa', color: '#333', 'border-radius': '4px' }" class="margin-t"
            :data="tableData" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有已布置作业数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column prop="clazz.name" align="center" width="120px" :label="$t('班级名称')">
            </el-table-column>
            <el-table-column prop="title" align="center" :label="$t('作业标题')">
            </el-table-column>
            <el-table-column prop="teacher.name" align="center" width="120px" :label="$t('布置老师')">
            </el-table-column>

            <el-table-column prop="records_count" align="center" width="80px" :label="$t('提交人数')">
            </el-table-column>
            <el-table-column prop="reviews_count" align="center" width="100px" :label="$t('待批改作业')">
            </el-table-column>
            <el-table-column prop="created_at" :label="$t('创建时间')">
            </el-table-column>

            <el-table-column prop="expiry_time" :label="$t('截止时间')">
            </el-table-column>

            <el-table-column prop="address" :label="$t('操作')" width="100px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="open(scope.row)">{{ $t('查看')
                    }}</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog top="40px" v-if="dalogVisible" custom-class="br" :visible.sync="dalogVisible" :close-on-click-modal="false"
            :show-close="false" width="70%" center>

            <h3 slot="title">{{ workItem.title }}</h3>

            <h4 class="flex flex-v-center flex-between padding">
                <div>{{ $t('班级') }} ：{{ workItem.clazz.name }}</div>
                <div>{{ $t('发布老师') }} ：{{ workItem.teacher.name }}</div>
                <div>{{ $t('发布时间') }} ：{{ workItem.created_at }}</div>
            </h4>

            <el-card shadow="never" class="margin-t">
                <h3 slot="header">{{ $t('作业内容') }}</h3>
                <div>{{ workItem.content }}</div>
                <div v-for="(item1, i) in workItem.attachment" :key="i">
                    <el-divider></el-divider>
                    <div class="flex flex-between flex-v-center">
                        <audio controls v-if="item1.type == 'audio'" :src="$host + item1.url"></audio>
                        <el-image :preview-src-list="[$host + item1.url]" v-else-if="item1.type == 'image'"
                            style="height: 100px;width: 200px;" fit="cover" :src="$host + item1.url"></el-image>
                        <el-link v-else-if="item1.type == 'file'">{{ item1.url.split('/').pop() }}</el-link>

                        <div class="flex flex-v-center">
                            <el-tooltip :content="$t('下载')">
                                <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                    icon="el-icon-download"></el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </el-card>


            <el-card shadow="never" class="margin-t">
                <h3 slot="header">{{ $t('学生列表') }}</h3>
                <el-table
                    :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                    class="margin-t" :data="record_list" style="width: 100%">
                     <el-table-column align="center" prop="user_id" :label="$t('User ID')">
                    </el-table-column>
                     <el-table-column align="center" prop="nickName" :label="$t('图像')">
                          <template slot-scope="scope">
                            <el-avatar :src="scope.row.avatar"></el-avatar>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="nickName" :label="$t('账号昵称')">
                    </el-table-column>
                    <el-table-column align="center" prop="user_time" :label="$t('提交时间')" width="160px">
                    </el-table-column>
                    <el-table-column align="center" prop="status" :label="$t('作业状态')">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0"  style="color:gray;">{{ $t('未提交') }}</el-tag>
                            <el-tag v-else-if="scope.row.status == 1"  style="color:#e6a13c;">{{ $t('待批改') }}</el-tag>
                            <el-tag v-else-if="scope.row.status == 2" style="color:green;">{{ $t('已批改') }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="status == 1" prop="latest_homework" :label="$t('批改时间')">
                    </el-table-column>

                    <!-- <el-table-column prop="address" :label="$t('操作')">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status > 0" size="mini" type="primary"
                                @click="open(scope.row)">{{
                                    scope.row.status == 2 ?
                                        $t('查看') :
                                        $t('批改')
                                }}</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-card>

            <span class="dialog-footer center" slot="footer">
                <el-button @click="dalogVisible = false">{{ $t('关 闭') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            name: '',
            tableData: [],
            record_list: [],
            dalogVisible: false,
            workItem: {}
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.$http.post('/api/work/list', { name: this.name }).then(data => {
                this.tableData = data;
            });
        },




        open(item) {
            this.workItem = item;
            this.$http.post('/api/work/records', { work_id: item.id }).then((list) => {
                this.record_list = list
                this.dalogVisible = true;
            })
        },
    }
};
</script>
